<template>
      <div class="alentours" id="haut" v-motion-pop>
            <!---- Petite paragraphe pour une bref description ---->
            <p class="bg-white bg-opacity-90 text-left alentours__paragraph">
                  Profitez de votre séjour pour découvrir notre région, sur
                  cette carte vous trouvevez quelques lieux à visiter dans un
                  rayon de 50 km : fermes, restaurants, sites touristiques,
                  paysages, randonnées, etc ...
            </p>

            <!-- Intégration de la carte avec l'api de google map -->
            <div class="alentours__carte">
                  <iframe
                        src="https://www.google.com/maps/d/u/0/embed?mid=12r6EtORX4TvW-tF_tddqwHYuHehKG0E&ehbc=2E312F"
                        width="100%"
                        height="600"
                  ></iframe>
            </div>

            <!-- 
                  Insertion des données comme les photos, le nom des sites aux alentours, le site web
                  des entreprises et le l'itinéraire vers gite le cormier via alentours.js
            -->
            <div class="monEnsemble">
                  <div
                        v-for="alentour in alentours"
                        :key="alentour.id"
                        class="monEnsemble__element"
                  >
                        <div
                              class="alentours__card"
                              data-aos="fade-right"
                              data-aos-duration="500"
                              data-aos-easing="ease-in-out"
                        >
                              <div class="alentours__card--image">
                                    <div class="myImage">
                                          <img
                                                :src="alentour.img"
                                                :alt="alentour.titre"
                                          />
                                    </div>

                                    <div class="mapButton">
                                          <button
                                                class="bg-green-600"
                                                v-if="alentour.maps != ''"
                                          >
                                                <a
                                                      :href="alentour.maps"
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      >Voir l'itinéraire</a
                                                >
                                          </button>
                                    </div>
                              </div>

                              <div class="alentours__card--description">
                                    <h1
                                          v-text="alentour.titre"
                                          class="font-bold"
                                    ></h1>

                                    <div class="site">
                                          <button
                                                class="bg-green-600"
                                                v-if="alentour.site != ''"
                                          >
                                                <a
                                                      :href="alentour.site"
                                                      target="_blank"
                                                      rel="noopener noreferrer"
                                                      >Site officiel</a
                                                >
                                          </button>
                                    </div>

                                    <!-- Tablette screen -->
                                    <div
                                          class="description_tablette_screen"
                                          v-if="alentour.site || alentour.maps"
                                    >
                                          <button
                                                class="bg-green-600 en-savoir-plus"
                                                @click="togglePopup(alentour)"
                                          >
                                                En savoir plus...
                                          </button>
                                    </div>

                                    <!-- Dialog plein écran -->
                                    <div
                                          v-if="showPopup === alentour.id"
                                          class="dialog-overlay"
                                    >
                                          <div class="dialog">
                                                <a
                                                      v-if="alentour.site"
                                                      :href="alentour.site"
                                                      target="_blank"
                                                      class="dialog-btn"
                                                >
                                                      Site officiel
                                                </a>

                                                <a
                                                      v-if="alentour.maps"
                                                      :href="alentour.maps"
                                                      target="_blank"
                                                      class="dialog-btn"
                                                >
                                                      Itinéraire
                                                </a>
                                          </div>
                                    </div>

                                    <!--<div class="description_tablette_screen" v-if="alentour.site || alentour.maps">
                                          <div v-if="alentour.site != ''">
                                                <button class="bg-green-600">
                                                      <a
                                                            :href="
                                                                  alentour.site
                                                            "
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            >Site officiel</a
                                                      >
                                                </button>
                                          </div>

                                          <div v-else>
                                                <button class="bg-green-600">
                                                      <a
                                                            :href="
                                                                  alentour.maps
                                                            "
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            >Voir
                                                            l'itinéraire</a
                                                      >
                                                </button>
                                          </div>
                                          <!-<div
                                                class="mapButton_tablette_screen"
                                          >
                                                <button
                                                      class="bg-green-600"
                                                      v-if="alentour.maps != ''"
                                                >
                                                      <a
                                                            :href="
                                                                  alentour.maps
                                                            "
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            >Voir
                                                            l'itinéraire</a
                                                      >
                                                </button>
                                          </div>

                                          <div>
                                                <button
                                                      class="bg-green-600"
                                                      v-if="alentour.site != ''"
                                                >
                                                      <a
                                                            :href="
                                                                  alentour.site
                                                            "
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            >Site officiel</a
                                                      >
                                                </button>
                                          </div>->
                                    </div>-->
                              </div>
                        </div>
                  </div>
            </div>

            <div class="bubble">
                  <h2>Quelques sites d'informations</h2>
            </div>

            <div class="monEnsemble">
                  <div
                        v-for="alentour in alentoursSiteInformation"
                        :key="alentour.id"
                        class="monEnsemble__element"
                  >
                        <div
                              class="alentours__card"
                              data-aos="fade-right"
                              data-aos-duration="500"
                              data-aos-easing="ease-in-out"
                        >
                              <div
                                    class="alentours__card--image"
                                    :class="{
                                          'bg-[#010f1b]':
                                                alentour.class == 'black',
                                    }"
                              >
                                    <div class="imageInformation">
                                          <img
                                                :src="alentour.img"
                                                :alt="alentour.titre"
                                          />
                                    </div>

                                    <div class="mapButton"></div>
                              </div>

                              <div
                                    class="alentours__card--description information"
                              >
                                    <h1
                                          v-text="alentour.titre"
                                          class="font-bold"
                                    ></h1>
                                    <button
                                          class="bg-green-600"
                                          v-if="alentour.site != ''"
                                    >
                                          <a
                                                :href="alentour.site"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                >Site officiel</a
                                          >
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>

            <div></div>

            <!-------------- Boutton de redirection------------------------------>
            <div class="alentours__redirection">
                  <button>
                        <a href="#haut">
                              <font-awesome-icon
                                    icon="fa-solid fa-arrow-up"
                                    class="alentours__redirection--font"
                              />
                        </a>
                  </button>
            </div>
      </div>
</template>

<script setup>
import { ref } from "vue";
import { alentours, alentoursSiteInformation } from "../database/alentours";

//var mapsButton = ref(false);
//var result = ref(true);

const showPopup = ref(null);
let timeout = null;

const togglePopup = (alentour) => {
      showPopup.value = alentour.id;

      clearTimeout(timeout);

      timeout = setTimeout(() => {
            showPopup.value = null;
      }, 2000);
};
</script>

<style lang="scss" scoped>
.alentours {
      margin-top: 3em;
      padding: 2em 0;
      width: 90%;
      margin: auto;
      transition: 0.25s ease-in;

      @media screen and (max-width: 769px) {
            margin-top: 1.5em;
            width: 99%;
      }

      @media screen and (max-width: 550px) {
            margin-top: 0.5em;
      }

      .monEnsemble {
            display: grid;
            grid-template-columns: repeat(3, 1fr);

            @media screen and (max-width: 769px) {
                  width: 100%;
                  grid-template-columns: repeat(2, 1fr);
                  grid-gap: 0.1em;
                  margin: 0;
            }

            @media screen and (max-width: 550px) {
                  grid-template-columns: repeat(1, 1fr);
            }

            &__element {
                  /*@media screen and (max-width: 769px){
                        width: 100%;
                        margin: auto;
                        padding: 0;
                  }*/

                  @media screen and (max-width: 550px) {
                        width: 95%;
                        margin: auto;
                        padding: 0;
                  }
            }
      }

      .bubble {
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            background: rgba(8, 160, 69, 0.8);
            color: #ffffff;
            //font-family: Arial;
            font-size: 1.1em;
            text-align: center;
            width: 20%;
            margin: auto;
            height: 10vh;
            border-radius: 10px;
            padding: 0px;

            @media screen and (max-width: 769px) {
                  width: 40%;
                  height: 8vh;
            }

            @media screen and (max-width: 550px) {
                  width: 45%;
                  margin-bottom: 0.5em;
            }

            &::after {
                  content: "";
                  position: absolute;
                  display: block;
                  width: 0;
                  z-index: 1;
                  border-style: solid;
                  border-width: 20px 20px 0 0;
                  border-color: rgba(8, 160, 69, 0.8) transparent transparent
                        transparent;
                  bottom: -20px;
                  left: 50%;
                  margin-left: -10px;

                  @media screen and (max-width: 550px) {
                        bottom: -19.5px;
                  }
            }
      }

      &__carte {
            margin-bottom: 1em;
      }

      &__paragraph {
            padding: 1em;
            border-radius: 0.5em;
            margin: 2.5em 0 1em 0;

            @media screen and (max-width: 769px) {
                  font-family: Arial, Helvetica, sans-serif;
            }
      }

      &__card {
            background: #fff;
            border-radius: 0.5em;
            margin: 1em;
            //position: relative;
            box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px,
                  rgba(0, 0, 0, 0.12) 0px -12px 30px,
                  rgba(0, 0, 0, 0.12) 0px 4px 6px,
                  rgba(0, 0, 0, 0.17) 0px 12px 13px,
                  rgba(0, 0, 0, 0.09) 0px -3px 5px;

            @media screen and (max-width: 769px) {
                  width: 95%;
            }

            @media screen and (max-width: 550px) {
                  width: 100%;
                  margin: 0;
                  margin-bottom: 1em;
            }

            &:hover {
                  transition: 0.5s;

                  .mapButton {
                        transition: ease-in-out 50s;
                        display: block;
                        background: rgba(170, 221, 204, 0.5);

                        @media screen and (max-width: 769px) {
                              display: none;
                        }

                        button {
                              animation: tada; /* referring directly to the animation's @keyframe declaration */
                              animation-duration: 2s; /* don't forget to set a duration! */
                        }
                  }
            }

            &--image {
                  position: relative;
                  height: 100%;

                  .myImage {
                        img {
                              width: 100%;
                              height: 250px;
                              display: flex;
                              justify-content: center;
                              align-items: center;
                              //object-fit: cover;
                        }
                  }

                  .imageInformation {
                        width: 100%;

                        img {
                              width: 100%;
                              margin: auto;
                              height: 250px;
                              object-fit: contain;
                        }
                  }

                  .mapButton {
                        width: 100%;
                        height: 100%;
                        position: absolute;
                        top: 0em;
                        display: none;

                        button {
                              padding: 0.5em;
                              border: 2px solid #fff;
                              color: #fff;
                              border-radius: 0.5em;
                              width: 32%;
                              margin: auto;
                              position: relative;
                              top: 45%;
                              background: rgb(22, 163, 74);
                              border: none;

                              @media screen and (max-width: 769px) {
                                    width: 50%;
                              }

                              &:hover {
                                    background: rgb(22, 163, 74);
                                    border: none;
                              }
                        }
                  }
            }

            &--description {
                  .description_tablette_screen {
                        display: none;

                        @media screen and (max-width: 769px) {
                              display: flex;
                              justify-content: center;
                        }

                        button {
                              @media screen and (max-width: 769px) {
                                    padding: 0.5em;
                                    margin: 0 0.5em 0.5em 0.3em;
                              }
                        }
                  }

                  .site {
                        @media screen and (max-width: 769px) {
                              display: none;
                        }
                  }

                  .mapButton_tablette_screen {
                        display: none;

                        @media screen and (max-width: 769px) {
                              display: block;
                        }
                  }
                  button {
                        color: #fff;
                        padding: 0.3em;
                        border-radius: 0.5em;
                        margin-bottom: 0.3em;

                        &:hover {
                              background: rgba(6, 123, 49, 0.5);
                        }
                  }
            }

            .information {
                  background: rgba(22, 163, 74, 0.5);
                  border-radius: 0.5em;
            }
      }

      &__redirection {
            text-align: right;

            &--font {
                  font-size: 1.5em;
                  padding: 0.7em;
                  border-radius: 50%;
                  margin-right: 0.5em;
                  background: #08a045;
                  color: #fff;
                  transform: translateX(2.5em);

                  @media screen and (max-width: 769px) {
                        transform: translateX(0em);
                  }
            }
      }


      @keyframes fadeIn {
            from {
                  opacity: 0;
            }
            to {
                  opacity: 1;
            }
      }

      .dialog-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 9999;
      }

      .dialog {
            //background: white;
            padding: 1.5em;
            border-radius: 12px;
            display: flex;
            gap: 1em;
            box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      }

      .dialog-btn {
            background: #16a34a;
            color: white;
            padding: 0.6em 1em;
            border-radius: 8px;
            white-space: nowrap;
      }

      .dialog-btn:hover {
            background: #15803d;
      }
}
</style>
